<template>
  <div class="pt-2 d-flex" style="overflow-y: hidden;">
    <v-card flat class="d-flex flex-column flex-grow-1 flex-shrink-1">
      <v-form v-model="valid" class="flex-grow-0 flex-shrink-0">
        <v-row no-gutters align="center">
          <v-col cols="1" style="text-align: right">
            <label>选择门店：</label>
          </v-col>
          <v-col cols="2">
            <pd-shop-multiple-list
                v-model="shopIds"
                isSearch
            ></pd-shop-multiple-list>
          </v-col>
          <v-col cols="1" style="text-align: right">
            <label>点位分类:</label>
          </v-col>
          <v-col cols="2">
            <v-select outlined dense clearable :items="pointList" item-value="id" item-text="pointName"
                      v-model="filter.pointId"></v-select>
          </v-col>
          <v-col cols="1" style="text-align: right">
            <label>点位编号：</label>
          </v-col>
          <v-col cols="2">
            <v-text-field
                class="form-item-value"
                v-model="filter.code"
                label=""
                outlined
                dense
            ></v-text-field>
          </v-col>
          <v-col cols="1" style="text-align: right">
            <label>点位名称：</label>
          </v-col>
          <v-col cols="2">
            <v-text-field
                class="form-item-value"
                v-model="filter.name"
                label=""
                outlined
                dense
            ></v-text-field>
          </v-col>
          <v-col cols="1" style="text-align: right">
            <label>点位状态：</label>
          </v-col>
          <v-col cols="2">
            <v-select
                v-model="filter.status"
                :items="statusList"
                item-text="name"
                item-value="id"
                clearable
                outlined
                dense
            ></v-select>
          </v-col>
		  <v-col cols="1" style="text-align: right">
		    <label>是否厅房点位：</label>
		  </v-col>
		  <v-col cols="2">
		    <v-select
		        v-model="filter.isTfPoint"
		        :items="isTfList"
		        item-text="name"
		        item-value="id"
		        clearable
		        outlined
		        dense
		    ></v-select>
		  </v-col>
          <v-col cols="2" offset="1">
            <v-btn color="primary" class="mx-2" depressed @click="handleSearch" v-if="_hasButtonPermission('查询')"
            >查询
            </v-btn>
            <v-btn depressed @click="handleResetSearch" v-if="_hasButtonPermission('查询')">重置</v-btn>
          </v-col>
        </v-row>
      </v-form>
      <div class="flex-grow-1 flex-shrink-1" style="position: relative">
        <div style="position: absolute; inset: 0px">
          <v-data-table
              ref="data"
              :headers="headers"
              fixed-header
              height="calc(100% - 64px - 59px)"
              style="height: 100%"
              :items="desserts"
              class="elevation-1 mt-2"
              :loading="loading"
              :server-items-length="totalDesserts"
              :page.sync="filter.pageNum"
              :items-per-page.sync="filter.pageSize"
              @update:page="handlePageChanged"
              @update:items-per-page="handlePageSizeChanged"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-btn color="primary" depressed class="mr-2" @click="batchExportQrcode"
                       v-if="_hasButtonPermission('批量导出二维码')">
                  批量导出二维码
                </v-btn>
                <v-btn color="primary" depressed class="mr-2" @click="doExport" v-if="_hasButtonPermission('导出巡检点位')">
                  导出巡检点位
                </v-btn>
                <v-btn color="primary" depressed class="mr-2" @click="doImport" v-if="_hasButtonPermission('导入巡检点位')">
                  导入巡检点位
                </v-btn>
				<v-btn color="primary" depressed class="mr-2" @click="doImportPointType" v-if="_hasButtonPermission('导入点位类型')">
				  导入点位类型
				</v-btn>
              </v-toolbar>
            </template>

            <template v-slot:[`item.status`]="{ item }">
              {{ item.status === 0 ? "禁用" : "启用" }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom v-if="_hasButtonPermission('导出二维码')">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small class="mr-2" @click="exportQrcode(item)" v-bind="attrs" v-on="on">
                    mdi-qrcode
                  </v-icon>
                </template>
                <span>导出二维码</span>
              </v-tooltip>
              <v-tooltip bottom v-if="_hasButtonPermission('编辑')">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-if="item.status===1" small @click="editItem(item)" v-bind="attrs" v-on="on"> mdi-pencil
                  </v-icon>
                </template>
                <span>编辑</span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.status===1 && _hasButtonPermission('禁用')">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-if="item.status===1" small @click="disableItem(item)" v-bind="attrs" v-on="on">
                    mdi-close-circle
                  </v-icon>
                </template>
                <span>禁用</span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.status===0  && _hasButtonPermission('启用')">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-if="item.status===0" small @click="enableItem(item)" v-bind="attrs" v-on="on">
                    mdi-check-circle
                  </v-icon>
                </template>
                <span>启用</span>
              </v-tooltip>
              <v-tooltip bottom v-if="_hasButtonPermission('查看巡检项')">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small class="ml-2" @click="pointItem(item)" v-bind="attrs" v-on="on">
                    mdi-format-list-bulleted
                  </v-icon>
                </template>
                <span>查看巡检项</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </div>
      <!--导入弹窗-->
      <v-dialog v-model="auditDialog" width="600">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"
          >导入门店点位
          </v-card-title
          >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <v-file-input
                      truncate-length="15"
                      label="选择excel"
                      small-chips
                      dense
                      v-model="importFile"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="handleImport"> 确认</v-btn>
            <v-btn color="primary" text @click="downloadTemplate">
              下载模板
            </v-btn>
            <v-btn text @click="auditDialog = false"> 取消</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
	  
	  <!--导入弹窗 点位类型-->
	  <v-dialog v-model="auditDialog2" width="600">
	    <v-card>
	      <v-card-title class="text-h5 grey lighten-2"
	      >导入点位类型
	      </v-card-title
	      >
	      <v-card-text>
	        <v-container>
	          <v-row>
	            <v-col>
	              <v-file-input
	                  truncate-length="15"
	                  label="选择excel"
	                  small-chips
	                  dense
	                  v-model="importFile"
	              ></v-file-input>
	            </v-col>
	          </v-row>
	        </v-container>
	      </v-card-text>
	      <v-divider></v-divider>
	      <v-card-actions>
	        <v-btn color="primary" text @click="handleImportPointType"> 确认</v-btn>
	        <v-btn color="primary" text @click="downloadPointTypeTemplate">
	          下载模板
	        </v-btn>
	        <v-btn text @click="auditDialog2 = false"> 取消</v-btn>
	      </v-card-actions>
	    </v-card>
	  </v-dialog>
      <!--修改弹窗-->
      <v-dialog v-model="edit.dialog" width="600">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"
          >修改门店点位
          </v-card-title
          >
          <v-card-text>
            <v-container>
              <v-form ref="shopPointForm">
                <v-row>
                  <v-col>
                    <shop-select label="门店" v-model="edit.item.shopId" :rules="[rules.required]"></shop-select>
                  </v-col>
                </v-row>
				<v-row>
				  <v-col>
				    <v-select label="点位版块" outlined dense clearable :rules="[rules.required]" :items="forumList"
				              item-value="id" item-text="forumName" v-model="edit.item.forumId"></v-select>
				  </v-col>
				</v-row>
                <v-row>
                  <v-col>
                    <v-select label="点位分类" outlined dense clearable :rules="[rules.required]" :items="getPointListByForumId(edit.item.forumId)"
                              item-value="id" item-text="pointName" v-model="edit.item.pointId"></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field label="点位编号" v-model="edit.item.pointCode" :rules="[rules.required]"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field label="点位名称" v-model="edit.item.pointName" :rules="[rules.required]"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field label="位置" v-model="edit.item.location" :rules="[rules.required]"></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="saveItem"> 保存</v-btn>
            <v-btn text @click="edit.dialog = false"> 取消</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!--查看巡检项弹窗-->
      <v-dialog v-model="view.dialog" width="600">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"
          >查看巡检项
          </v-card-title
          >
          <v-card-text>
            <v-container>
              <v-row>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                    <tr>
                      <td>巡检项编号</td>
                      <td>巡检项</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in view.itemList">
                      <td>{{ item.id }}</td>
                      <td>{{ item.itemName }}</td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn text @click="view.dialog = false"> 取消</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import ShopPointApi from "@/api/pd/inspection/ShopPointApi";
import {default as downloadUtil} from "@/util/downloadUtil";
import {default as PermissionApi} from "@/api/smp/auth/Permission";
import ShopSelect from "@/components/pd/common/ShopList";
import BudgetEditionApi from "@/api/pd/budget/BudgetEdition";
import PdForumApi from "@/api/pd/forum/PdForumApi.js";

export default {
  name: "Pd-Manager-Shop-Point",
  components: {ShopSelect},
  props: {
    page: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      rules: {
        required: value => (((!Array.isArray(value) && !!value) || (Array.isArray(value) && value.length > 0)) || value === 0) || '必填.',
      },
      statusList: [
        {id: 1, name: "启用"},
        {id: 0, name: "禁用"},
      ],
	  isTfList: [
	    {id: 1, name: "是"},
	    {id: 0, name: "否"},
	  ],
      buttonPriviledgeList: [],
      subjectList: [],
	  forumList:[],
      pointList: [],
      shopIds: [],
      filter: {
        shopIds: "",
        pointId: "",
        code: "",
        name: "",
        subjectId: "",
		isTfPoint:"",
        status: undefined,
        pageNum: 1,
        pageSize: 15,
      },
      headers: [
        {
          text: "编号",
          value: "id",
          sortable: false,
          width: 65,
          divider: true,
          groupable: false
        },
        {
          text: "门店名称",
          value: "shopName",
          sortable: false,
          width: 100,
          divider: true,
        },
		{
		  text: "版块名称",
		  align: "start",
		  sortable: false,
		  value: "forumName",
		  width: 120,
		  divider: true,
		  groupable: false
		},
        {
          text: "点位名称",
          align: "start",
          sortable: false,
          value: "pointName",
          width: 120,
          divider: true,
          groupable: false
        },
        {
          text: "点位编号",
          align: "start",
          sortable: false,
          value: "pointCode",
          width: 120,
          divider: true,
          groupable: false
        },
        {
          text: "点位分类",
          align: "start",
          sortable: false,
          value: "pointType",
          width: 120,
          divider: true,
          groupable: false
        },
        {
          text: "位置",
          align: "start",
          sortable: false,
          value: "location",
          width: 120,
          divider: true,
          groupable: false
        },
        {
          text: "状态",
          align: "start",
          sortable: false,
          value: "status",
          width: 80,
          divider: true,
          groupable: false
        },
        {
          text: "最后修改人",
          align: "start",
          sortable: false,
          value: "updateBy",
          width: 80,
          divider: true,
          groupable: false
        },
        {
          text: "最后修改时间",
          align: "start",
          sortable: false,
          value: "updateTime",
          width: 150,
          divider: true,
          groupable: false
        },
        {
          text: "操作",
          align: "start",
          sortable: false,
          value: "actions",
          width: 150,
          divider: true,
          groupable: false
        },
      ],
      desserts: [],
      loading: false,
      totalDesserts: 0,
      valid: false,
      auditDialog: false,
	  auditDialog2 : false,
      checkId: null,
      btnDisabled: false,
      importFile: undefined,
      edit: {
        dialog: false,
        item: {},
      },
      view: {
        dialog: false,
        itemList: [],
      }
    };
  },
  mounted() {
    this.getButtonPriviledge();
    this.getSubjectList();
    this.getPointList();
	this.getForumList();
  },
  methods: {
    async getSubjectList() {
      let res = await ShopPointApi.allSubject();
      if (res.data.code === 200) {
        this.subjectList = res.data.data;
      } else {
        me.$dialog.error({
          text: res.data.msg,
          title: "操作失败",
        });
      }
    },
	async getForumList() {
	 let res = await PdForumApi.all();
	 if (res.status === 200) {
	   this.forumList = res.data.data;
	 }
	},
    async getPointList() {
      let res = await ShopPointApi.allPoint();
      if (res.data.code === 200) {
        this.pointList = res.data.data;
      } else {
        me.$dialog.error({
          text: res.data.msg,
          title: "操作失败",
        });
      }
    },
    handleSearch() {
      if (!this.shopIds || this.shopIds.length == 0) {
        this.$dialog.error({
          title: '错误',
          text: '请选择门店'
        })
        return
      }
      this.filter.pageNum = 1
      this.getDataFromApi();
    },
    handleResetSearch() {
      this.shopIds = [];
      this.filter = {
        shopIds: "",
        pointId: "",
        code: "",
        name: "",
        subjectId: "",
        status: undefined,
        pageNum: 1,
        pageSize: 15,
      };
    },
    handlePageChanged(pageNum) {
      this.filter.pageNum = pageNum;
      this.getDataFromApi();
    },
    handlePageSizeChanged(pageSize) {
      if (pageSize == -1) {
        pageSize = 100;
      }
      this.filter.pageNum = 1;
      this.filter.pageSize = pageSize;
      this.getDataFromApi();
    },
    async getDataFromApi() {
      let me = this;
      me.loading = true;
      me.filter.shopIds = me.shopIds.join(",");
      let queryUserResp = await ShopPointApi.list(me.filter);
      console.log("load user returned;");
      console.log(queryUserResp);
      let data = queryUserResp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取门店点位情况失败" : msg;
        me.loading = false;
        throw new Error(msg);
      }
      if (!data.data || !data.data.rows) {
        me.loading = false;
        throw new Error("获取门店点位情况失败(无会话数据)");
      }
      me.loading = false;
      me.desserts = data.data.rows;
      me.totalDesserts = data.data.total;
    },
    async exportData() {
      let me = this;
      me.filter.shopIds = me.shopIds.join(",");
      let res = await ShopPointApi.exportData(me.filter);
      downloadUtil.downloadByBlob({res: res.data, fileName: "导出结果.xlsx"});
    },
    doImport() {
      this.auditDialog = true;
    },
	doImportPointType() {
	  this.auditDialog2 = true;
	},
    async handleImport() {
      let me = this;
      let file = me.importFile;
      if (!file || !file.size) {
        me.$dialog.error({
          text: "文件必传",
          title: "操作失败",
        });
        return;
      }
      let res = await ShopPointApi.importData(file);
      console.log("导入结果", res);
      if (res.data.code === 200) {
        if (res.data.data) {
          me.$dialog.error({
            text: res.data.data,
            title: "操作失败",
          });
        } else {
          me.$dialog.info({
            text: res.data.msg,
            title: "操作成功",
          });
        }
        // me.getDataFromApi();
      } else {
        me.$dialog.error({
          text: res.data.msg + ':' + res.data.msg_detail,
          title: "操作失败",
        });
      }
      me.auditDialog = false;
      me.importFile = undefined;
    },
    async downloadTemplate() {
      let me = this;
      let res = await ShopPointApi.importTemplate();
      downloadUtil.downloadByBlob({res: res.data, fileName: "导入模板.xlsx"});
    },
	async downloadPointTypeTemplate() {
	  let me = this;
	  let res = await ShopPointApi.importPointTypeTemplate();
	  downloadUtil.downloadByBlob({res: res.data, fileName: "导入模板.xlsx"});
	},
	async handleImportPointType() {
	  let me = this;
	  let file = me.importFile;
	  if (!file || !file.size) {
	    me.$dialog.error({
	      text: "文件必传",
	      title: "操作失败",
	    });
	    return;
	  }
	  let res = await ShopPointApi.importPointTypeData(file);
	  console.log("导入结果", res);
	  if (res.data.code === 200) {
	    if (res.data.data) {
	      me.$dialog.error({
	        text: res.data.data,
	        title: "操作失败",
	      });
	    } else {
	      me.$dialog.info({
	        text: res.data.msg,
	        title: "操作成功",
	      });
	    }
	    // me.getDataFromApi();
	  } else {
	    me.$dialog.error({
	      text: res.data.msg + ':' + res.data.msg_detail,
	      title: "操作失败",
	    });
	  }
	  me.auditDialog = false;
	  me.importFile = undefined;
	},
    doExport() {
      if (!this.shopIds || this.shopIds.length == 0) {
        this.$dialog.error({
          title: '错误',
          text: '请选择门店'
        })
        return
      }
      let me = this;
      me.exportData();
    },
    getButtonPriviledge() {
      console.log('this.page', this.page)
      let menuId = this.page.id
      let me = this
      PermissionApi.queryButtonPriviledge(menuId, null).then(resp => {
        PermissionApi.handleResponse(resp, me, function (data) {
          me.buttonPriviledgeList = data.buttonPriviledges
          console.log('buttonPriviledgeList', me.buttonPriviledgeList)
        })
      })
    },
    _hasButtonPermission(name) {
      let buttonPriviledgeList = this.buttonPriviledgeList;
      let hasButton = false;
      for (let i = 0; i < buttonPriviledgeList.length; i++) {
        if (buttonPriviledgeList[i].name == name) {
          if (buttonPriviledgeList[i].hasPriviledge == "Y") {
            return true;
          } else {
            return false;
          }
        }
      }
      return false;
    },
    editItem(item) {
      item.shopId = item.shopId + '';
      this.edit.item = item;
      this.edit.dialog = true;
    },
    async saveItem() {
      let valid = this.$refs.shopPointForm.validate();
      if (valid) {
        let res = await ShopPointApi.save(this.edit.item);
        if (res.data.code === 200) {
          this.$dialog.info({
            text: res.data.msg,
            title: "操作成功",
          });
          this.edit.dialog = false;
          this.getDataFromApi();
        } else {
          this.$dialog.error({
            text: res.data.msg + ':' + res.data.msg_detail,
            title: "操作失败",
          });
        }
      }
    },
    async disableItem(item) {
      let me = this;
      let confirm = await me.$dialog.confirm({
        text: "确认停用门店点位吗？",
        title: "提示",
      });
      if (confirm) {
        let res = await ShopPointApi.disable(item.id);
        if (res.data.code === 200) {
          me.$dialog.info({
            text: res.data.msg,
            title: "操作成功",
          });
          me.getDataFromApi();
        } else {
          me.$dialog.error({
            text: res.data.msg,
            title: "操作成功",
          });
        }
      }
    },
    async enableItem(item) {
      let me = this;
      let confirm = await me.$dialog.confirm({
        text: "确认启用门店点位吗？",
        title: "提示",
      });
      if (confirm) {
        let res = await ShopPointApi.enable(item.id);
        if (res.data.code === 200) {
          me.$dialog.info({
            text: res.data.msg,
            title: "操作成功",
          });
          me.getDataFromApi();
        } else {
          me.$dialog.error({
            text: res.data.msg,
            title: "操作成功",
          });
        }
      }
    },
    async pointItem(item) {
      let res = await ShopPointApi.item({pointId: item.pointId});
      if (res.data.code === 200) {
        this.view.itemList = res.data.data;
        this.view.dialog = true;
      } else {
        me.$dialog.error({
          text: res.data.msg,
          title: "操作失败",
        });
      }
    },
    async batchExportQrcode() {
      if (!this.shopIds || this.shopIds.length == 0) {
        this.$dialog.error({
          title: '错误',
          text: '请选择门店'
        })
        return
      }
      this.$dialog.info({title: "提醒", text: "生成下载中，下载sh前请勿关闭本页面"});
      let me = this;
      me.filter.shopIds = me.shopIds.join(",");
      let res = await ShopPointApi.batchExportQrcode(me.filter);
      if (res.data) {
        downloadUtil.downloadByBlob({res: res.data, fileName: "qrcode.zip"});
      } else {

      }
    },
    async exportQrcode(item) {
      let me = this;
      let res = await ShopPointApi.exportQrcode({id: item.id});
      if (res.data) {
        downloadUtil.downloadByBlob({res: res.data, fileName: decodeURI(res.headers.filename)});
      } else {

      }
    },
	getPointListByForumId(forumId){
		 console.log(forumId)
		if(forumId==undefined || forumId==null || forumId==''){
			return [];
		}
		console.log(this.pointList)
		let list = []
		// let pointList=this.pointList
		// if(pointList!=null && pointList.length>0){
		// 	list=pointList.filter(it=>{
		// 		return it.forumId==forumId
		// 	})
		// }
		// console.log('list',list)
		// return list;
		return this.pointList;
	}

  },
};
</script>
<style scoped>
.padding-bottom {
  padding: 0 16px;
  /**padding-bottom: 12px;**/
}

.padding-top {
  padding-top: 30px;
}

.margin-right {
  margin-right: 12px;
}
</style>